'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');

function FavoriteMerchants({ merchants = [], routes, show }) {
  if (!show) {
    return null;
  }

  if (!merchants || !merchants.length) {
    return null;
  }

  return h(
    '.favorite-merchants',
    {
      'data-bhw': 'FavoriteMerchants',
    },
    h(
      Translate,
      { tag: 'h2', attrs: { class: 'secondary-title' } },
      'modules.merchant.Favorites'
    ),
    h(
      '.favorite-merchants-content',
      merchants.map(merchant =>
        h(
          'a',
          {
            href: routes.merchant.show.replace(
              '{merchantSlug}',
              merchant.merchantSlug
            ),
            'data-bhc': `merchant:${merchant.merchantSlug}`,
          },
          [
            MerchantLogoImage({
              lazyload: false,
              data: merchant.merchantMedia,
              size: { width: 114, height: 114 },
              alt: merchant.merchantName,
            }),
            h(
              Translate,
              { 0: merchant.offerCount },
              'modules.merchant.CouponsCount'
            ),
          ]
        )
      )
    )
  );
}

module.exports = FavoriteMerchants;
